export const company = process.env.MIX_APP_COMPANY
export const companyLink = process.env.MIX_APP_COMPANY_LINK